import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router'
import { useAuthStore } from '@/plugins/w/auth/store/auth.store'
import axios from 'axios'

import './modules/theme'
import pluginsModule from './modules/plugins'
import componentsModule from './modules/components'
import globalPropertiesModule from './modules/global-properties'
import { prepareTokenHandshakeSession, setupTokenHandshake } from './modules/token-handshake'
import { setupTokenHandshakeGuards } from './modules/token-handshake-guards'

prepareTokenHandshakeSession()

const app = createApp(App)
	.use(pluginsModule)
	.use(componentsModule)
	.use(globalPropertiesModule)

setupTokenHandshakeGuards()

axios.interceptors.request.use(request => {
	const authStore = useAuthStore()
	const access = authStore.getCurrentAccess
	const ocAccess = authStore.getCurrentOcAccess

	if (!request.headers.hasOwnProperty('Access-Id') && access)
		request.headers['Access-Id'] = access.id

	if (!request.headers.hasOwnProperty('Sampling-Center-Id') && ocAccess)
		request.headers['Sampling-Center-Id'] = ocAccess.sampling_center.id

	return request
})

// JSON-RPC integrácia pre Host aplikáciu cez postMessage (login, gridcard, logout)
setupTokenHandshake(router)

router.isReady().then(() => {
	app.mount('#app')
})
